<template>
  <div>
    <Tooltip placement="right">
      <div slot="content">
        <img v-bind:src="screenshotUrl" style="width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
                "/>
      </div>
      <div :style="spanStyle">
        <span>{{url}}</span>
      </div>

    </Tooltip>
  </div>
</template>

<script>
  export default {
    name: "EvidenceWebpageTipImg",
    props:{
      screenshotUrl: String,
      url: String,
    },
    data(){
      return {
        spanStyle: {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          minWidth: 240
        }
      };
    }
  }
</script>

<style scoped>

</style>